//Almacenamos la informacion seleccionada del usuario en los campos
export async function insertValue(data, id, value) {
  Object.keys(data)?.map(item => {
    data[item]?.map(itemAtt => {
      if (itemAtt.id === id) {
        itemAtt.value = value;
      }
      return true;
    });
    return true;
  });
}

//Validamos si los campos son requiridos y devolvemos la informacion para el guardado
export function validateData(data, setError, valueField) {
  let errorField = {};
  let jsonSend = {
    id_subtipoDocumento: Number(process.env.REACT_APP_ID_SUBTIPO),
  };

  Object.keys(data).map(item => {
    data[item]?.map(itemAtt => {
      if (itemAtt.obligatorio && !valueField[itemAtt.id]) {
        errorField[itemAtt.id] = 'Este campo es Obligatorio';
      }
      if (item === 'atributos') {
        data.atributos.forEach((atributo, index) => {
          if (atributo.parametro) {
            delete atributo.parametro;
          }
          if (itemAtt.id === atributo.id) {
            if (atributo.tipo === 'lista') {
              const optionSelected = getValueOption(
                atributo.opciones,
                valueField,
              );
              const nuevoTexto = optionSelected
                ? optionSelected
                : valueField[itemAtt.id];
              data.atributos[index] = {
                ...atributo,
                id_atributo: itemAtt.id,
                texto: nuevoTexto,
                seleccionados: [valueField[itemAtt.id]],
              };
              return;
            } else {
              let nuevoTexto = atributo.texto
                ? atributo.texto
                : valueField[itemAtt.id];
              if (atributo.tipo === 'archivo') {
                nuevoTexto = 'archivo';
              }
              if (atributo.tipo === 'multipleSeleccion') {
                data.atributos[index] = {
                  ...atributo,
                  id_atributo: itemAtt.id,
                  texto: nuevoTexto,
                  seleccionados: nuevoTexto ? nuevoTexto.split(',') : [],
                };
              } else {
                data.atributos[index] = {
                  ...atributo,
                  id_atributo: itemAtt.id,
                  texto: nuevoTexto,
                };
              }
            }
          }
        });
        jsonSend.atributos = data.atributos;
      } else {
        jsonSend[itemAtt.id] = valueField[itemAtt.id];
      }

      return true;
    });
    return true;
  });
  setError(errorField);
  if (Object.keys(errorField).length > 0) {
    return false;
  }
  return jsonSend;
}

//Formateamos la fecha para el guardado
export const getFormattedDate = dateNew => {
  let date = new Date(dateNew);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();

  if (month < 10) {
    // return `${year}/0${month}/${day} ${hours}:${minutes}`
    return `${year}/0${month}/${day}`;
  } else {
    //return `${year}/${month}/${day} ${hours}:${minutes}`
    return `${year}/${month}/${day}`;
  }
};

//Vaciamos el formulario
export function clearForm(hooks) {
  let data = {};
  hooks(state => {
    Object.keys(state)?.map(item => {
      const renderItem = state[item]?.map(itemAtt => {
        itemAtt.value = undefined;
        return itemAtt;
      });
      data[item] = renderItem;
      return true;
    });

    return data;
  });
}

function getValueOption(paramObject, fields) {
  for (const key in fields) {
    const id = parseInt(fields[key]);
    if (!isNaN(id)) {
      const match = paramObject.find(option => option.id === id);
      if (match) {
        return match.opcion;
      }
    }
  }
  return null;
}
